import {
  Container,
  Card,
  Typography,
  Stack,
  TextField,
  FormControl,
  Button,
  Box,
  Grid,
  CardContent,
  Autocomplete,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, useFormik, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { Link, Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import Page from '../components/Page';

export const CreateTaskFromTask = () => {
  const [members, setMembers] = useState([]);
  const [projectCategory, setProjectCategory] = useState();
  const [subTasks, setSubTasks] = useState();
  const [searchParams] = useSearchParams();
  console.log('searchParams', searchParams);
  const category = searchParams.get('category');
  const id = searchParams.get('id');
  const getMembers = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/project/manager/members`, {
        params: { projectId: id },
      })
      .then((res) => {
        setMembers(
          res.data.data.members.filter((item) => {
            return item.isBlocked === false;
          })
        );
      });
  };

  const getOneList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/tasklist/manager/view`, { params: { category, projectId: id } })
      .then((res) => {
        console.log('getOneList', res);
        setProjectCategory(res.data.data.tasks);
        setSubTasks(res.data.data.task.subTask);
        console.log('getdsf', res.data.data.task.subTask);
      });
  };
  // const subTasks = () => {
  //   projectCategory.subTask.map((pc) => pc);
  // };

  const navigate = useNavigate();
  // const { id } = useParams();
  // console.log('projext', id);

  useEffect(() => {
    getMembers();
    getOneList();
  }, []);

  const TaskSchema = Yup.object().shape({
    name: Yup.string().required('Name required'),
    // category: Yup.string().required('Category required'),
    startDate: Yup.date(),
    endDate: Yup.date(),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      projectId: id,
      name: '',
      // category: '',
      description: '',
      startDate: '',
      endDate: '',
      members: '',
    },
    validationSchema: TaskSchema,
    onSubmit: async () => {
      console.log('values', values);
      try {
        await axios
          .post(`${process.env.REACT_APP_API_URL}/task/manager`, { ...values, category })
          .then((res) => {
            toast.success(res.data.message);
            navigate(-1);
          })
          .catch((err) => {
            toast.error('something went wrong');
            console.log(err);
          });
      } catch (error) {
        console.log(error);
        return false;
      }
    },
  });

  const { errors, touched, handleSubmit, handleChange, setFieldValue, values, getFieldProps } = formik;
  return (
    <Page title="Project : Add task">
      <Container>
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
            <Typography variant="h4">Create Task</Typography>
            <CloseIcon onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
          </div>
          <CardContent>
            <FormikProvider value={formik}>
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2} xs={12}>
                  <Grid item xs={6}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      {/* <Typography variant="h6">Category</Typography> */}
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">{category}</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="category"
                          label="Select Category"
                          sx={{ width: '100%', height: '55px' }}
                          disabled
                        >
                          <MenuItem value={category}>{category}</MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h6">Name</Typography>
                      <FormControl fullWidth sx={{ m: 1, minWidth: 250 }}>
                        <InputLabel id="demo-simple-select-label">Name</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="name"
                          label="Select name"
                          sx={{ width: '100%', height: '55px' }}
                          {...getFieldProps('name')}
                          onChange={formik.handleChange}
                        >
                          {subTasks?.map((subTask, i) => {
                            return (
                              <MenuItem key={i} value={subTask.name}>
                                {subTask.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Stack>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h6">Description</Typography>
                      <TextField
                        label="Enter description"
                        name="description"
                        type="text"
                        {...getFieldProps('description')}
                        error={Boolean(touched.description && errors.description)}
                        fullWidth
                      />
                    </Stack>
                  </Grid>

                  <Grid item lg={4} md={5} sm={6} xs={12}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h6">Start date</Typography>
                      <TextField
                        label=""
                        name="startDate"
                        type="date"
                        {...getFieldProps('startDate')}
                        error={Boolean(touched.startDate && errors.startDate)}
                      />
                    </Stack>
                  </Grid>

                  <Grid item lg={4} md={5} sm={6} xs={12}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h6">End date</Typography>
                      <TextField
                        label=""
                        name="endDate"
                        type="date"
                        {...getFieldProps('endDate')}
                        error={Boolean(touched.endDate && errors.endDate)}
                      />
                    </Stack>
                  </Grid>

                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h6">Members</Typography>
                      <FormControl sx={{ m: 1, width: 300 }}>
                        <Autocomplete
                          multiple
                          id="multiple-limit-tags"
                          name="members"
                          options={members}
                          getOptionLabel={(option) => option.fullname}
                          onChange={(e, value) => {
                            const temp = value.map((item, index) => {
                              return item._id;
                            });
                            setFieldValue('members', temp);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select members"
                              placeholder="Members"
                              onChange={handleChange}
                              // {...getFieldProps('members')}
                              error={Boolean(touched.members && errors.members)}
                            />
                          )}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="row" marginY={2} justifyContent="center" alignItems="center" spacing={2}>
                      <Button variant="contained" type="submit" sx={{ bgcolor: "#6b4f25", ":hover": { background: "#543d1b" } }}>
                        Create
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </CardContent>
        </Card>
        {/* <Typography variant="h4" padding={1}>
          Create Task
        </Typography>
        <Card>
          <div style={{ display: 'flex', justifyContent: 'right', margin: '10px' }}>
            <CloseIcon onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
          </div>
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
            <FormikProvider value={formik}>
              <Box sx={{ display: 'flex', paddinBottom: '10px' }}>
                <Form onSubmit={handleSubmit}>
                  <Stack direction={'row'} spacing={5} paddingTop={5}>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <Typography variant="h6">Category</Typography>
                      <FormControl fullWidth sx={{ m: 1, minWidth: 250 }}>
                        <InputLabel id="demo-simple-select-label">{category}</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="category"
                          label="Select Category"
                          sx={{ width: '100%', height: '55px' }}
                          disabled
                        >
                          <MenuItem value={category}>{category}</MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <Typography variant="h6">Name</Typography>
                      <FormControl fullWidth sx={{ m: 1, minWidth: 250 }}>
                        <InputLabel id="demo-simple-select-label">Name</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="name"
                          label="Select name"
                          sx={{ width: '100%', height: '55px' }}
                          {...getFieldProps('name')}
                          onChange={formik.handleChange}
                        >
                          {subTasks?.map((subTask, i) => {
                            return (
                              <MenuItem key={i} value={subTask.name}>
                                {subTask.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Stack>
                  </Stack>

                  <Stack direction={'row'} spacing={2} paddingTop={5} alignItems="center">
                    <Typography variant="h6">Description</Typography>
                    <TextField
                      label="Enter description"
                      name="description"
                      type="text"
                      {...getFieldProps('description')}
                      error={Boolean(touched.description && errors.description)}
                      fullWidth
                    />
                  </Stack>

                  <Stack direction={'row'} spacing={5} paddingTop={5}>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <Typography variant="h6">Start date</Typography>
                      <TextField
                        label=""
                        name="startDate"
                        type="date"
                        {...getFieldProps('startDate')}
                        error={Boolean(touched.startDate && errors.startDate)}
                      />
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <Typography variant="h6">End date</Typography>
                      <TextField
                        label=""
                        name="endDate"
                        type="date"
                        {...getFieldProps('endDate')}
                        error={Boolean(touched.endDate && errors.endDate)}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" spacing={4} paddingTop={5} alignItems="center">
                    <Typography variant="h6">Members</Typography>
                    <FormControl sx={{ m: 1, width: 300 }}>
                      <Autocomplete
                        multiple
                        id="multiple-limit-tags"
                        name="members"
                        options={members}
                        getOptionLabel={(option) => option.fullname}
                        // defaultValue={[top100Films[13]]}
                        // filterSelectedOptions

                        onChange={(e, value) => {
                          const temp = value.map((item, index) => {
                            return item._id;
                          });
                          setFieldValue('members', temp);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select members"
                            placeholder="Members"
                            onChange={handleChange}
                            // {...getFieldProps('members')}
                            error={Boolean(touched.members && errors.members)}
                          />
                        )}
                      />
                    </FormControl>
                  </Stack>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      paddingTop: '40px',
                      paddingBottom: '20px',
                    }}
                  >
                    <Button variant="contained" type="submit">
                      Create
                    </Button>
                  </div>
                </Form>
              </Box>
            </FormikProvider>
          </div>
        </Card> */}
      </Container>
    </Page>
  );
};
